module.exports = __webpack_public_path__ + "img/ico-messages.5a50939b.svg";